/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownSubdivision } from '../models/db_DropdownSubdivision';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Subdivisions {
    /**
     * Get a list of subdivisions
     * @returns db_DropdownSubdivision OK
     * @throws ApiError
     */
    public static listSubdivisions(): CancelablePromise<Array<db_DropdownSubdivision>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/subdivisions',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
